import React from "react";
import { Field, ErrorMessage, FieldInputProps } from "formik";
import PasswordInputWithToggle from "../../../components/password-input-with-toggle/password-input-with-toggle";
import { TitleInput } from "@/screens/register/register-seller/style";
import { ErrorText, MarginBottom } from "@/screens/login/login-seller/style";

const StepAccess: React.FC = () => {
  return (
    <>
      <TitleInput>Senha</TitleInput>
      <Field name="password">
        {({ field }: { field: FieldInputProps<any> }) => (
          <PasswordInputWithToggle field={field} placeholder="Digite sua senha" />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="password" />
      </ErrorText>

      <MarginBottom />

      <TitleInput>Confirme a Senha</TitleInput>
      <Field name="confirm_password">
        {({ field }: { field: FieldInputProps<any> }) => (
          <PasswordInputWithToggle field={field} placeholder="Confirme sua senha" />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="confirm_password" />
      </ErrorText>
    </>
  );
};

export default StepAccess;